import type { BuildingId } from '@/interfaces/Building.interface';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import type { IpeHistoryTileData } from '../../interfaces/Tile.interface';
import { AdvizeoCoreIpeHistoryProvider } from './advizeo-core-ipe-history.provider';

@Injectable({
    providedIn: 'root'
})
export class IpeHistoryProvider {
    private _advizeoCoreIpeHistoryProvider = inject(AdvizeoCoreIpeHistoryProvider);

    fetchIpeHistoryById(tileId: string, step: string = 'YEARLY', isVatIncl: boolean, buildingId: BuildingId): Promise<IpeHistoryTileData> {
        return new Promise((resolve, reject) => {
            firstValueFrom(this._advizeoCoreIpeHistoryProvider.getIpeHistoryById$(tileId, step, isVatIncl, buildingId))
                .then((tileHistory: IpeHistoryTileData) => {
                    if (tileHistory) {
                        resolve(tileHistory);
                    } else {
                        reject('no tile history was provided');
                    }
                })
                .catch(e => {
                    reject(e);
                });
        });
    }

    getIpePreviewHistory(previewConfig: any, step: string = 'YEARLY') {
        return new Promise<IpeHistoryTileData>((resolve, reject) => {
            firstValueFrom(this._advizeoCoreIpeHistoryProvider.getIpePreviewHistory$(previewConfig, step))
                .then((tileHistory: IpeHistoryTileData) => {
                    resolve(tileHistory);
                })
                .catch(e => {
                    reject(e);
                });
        });
    }
}
